import React from 'react';
import { useLocation } from 'react-router-dom';
import { TopBar } from '../components/layout/TopBar';
import { Header } from '../components/layout/Header';
import { Navigation } from '../components/layout/Navigation';
import { MobileStickyBar } from '../components/layout/MobileStickyBar';
import { Footer } from '../components/layout/Footer';
import { ArrowLeft, ExternalLink } from 'lucide-react';
export function LegacyPreview() {
  const location = useLocation();
  return <div className="min-h-screen flex flex-col bg-brand-cream" data-id="element-2010">
      <TopBar data-id="element-2011" />
      <Header data-id="element-2012" />
      <Navigation data-id="element-2013" />

      <main className="flex-grow flex items-center justify-center px-4 py-20" data-id="element-2014">
        <div className="max-w-xl w-full bg-white rounded-2xl border border-brand-border shadow-sm p-8 lg:p-12 text-center" data-id="element-2015">
          <div className="w-14 h-14 rounded-full bg-brand-green/10 text-brand-green flex items-center justify-center mx-auto mb-6" data-id="element-2016">
            <ExternalLink size={26} data-id="element-2017" />
          </div>
          <h1 className="text-2xl lg:text-3xl font-serif font-bold text-brand-charcoal mb-3" data-id="element-2018">
            Legacy Website Forge URL
          </h1>
          <p className="text-gray-600 leading-relaxed mb-2" data-id="element-2019">
            This preview preserves the legacy Website Forge URL for this
            section.
          </p>
          <p className="text-sm text-gray-500 font-mono bg-brand-cream border border-brand-border rounded-md px-3 py-2 inline-block mb-8 break-all" data-id="element-2020">
            {location.pathname}
          </p>
          <div className="flex flex-col sm:flex-row gap-3 justify-center" data-id="element-2021">
            <a href="/Home.html" className="inline-flex items-center justify-center gap-2 bg-brand-green hover:bg-brand-green/90 text-white px-6 py-3 rounded-md font-semibold transition-colors" data-id="element-2022">
              <ArrowLeft size={18} data-id="element-2023" /> Back to Home
            </a>
            <a href="/ContactUs.html" className="inline-flex items-center justify-center bg-white border border-brand-border hover:border-brand-green text-brand-charcoal px-6 py-3 rounded-md font-semibold transition-colors" data-id="element-2024">
              Contact / Get help
            </a>
          </div>
        </div>
      </main>

      <Footer data-id="element-2025" />
      <MobileStickyBar data-id="element-2026" />
    </div>;
}